// eslint-disable-next-line no-restricted-imports

import React, { useContext } from 'react';
import styled from 'styled-components';
import { ProductFixedPriceProjectFragment } from '@99designs/apps/spa/pages/create/briefs/Brief.generated';
import Heading from '@99designs/apps/spa/pages/create/common/components/Heading';
import Header from '@99designs/apps/spa/pages/create/components/Header';
import HeaderUserLayout from '@99designs/apps/spa/pages/create/components/HeaderUserLayout';
import { StepState } from '@99designs/apps/spa/pages/create/util/step';
import { BriefPackage } from '@99designs/brief';
import { PartnerLogo } from '@99designs/brief';
import { BehaviourReactRouterLink, Box, Link, Stack } from '@99designs/emu';
import { colors } from '@99designs/emu/settings';
import { IconLeft1 } from '@99designs/icons';
import { PartnerContext } from '@99designs/spa-common';
import ContentSetting from './ContentSetting';
import { Designer as DesignerInterface } from './User';

interface Props {
    step: StepState;
    designers: DesignerInterface[];
    briefProduct?: ProductFixedPriceProjectFragment | null;
}

const Muted = styled.span`
    color: ${colors.grey700};
`;

export default function StepHeader({ step, designers, briefProduct }: Props) {
    const { partner } = useContext(PartnerContext);

    return (
        <ContentSetting>
            <Header title={`${step.currentStep().title}`} textAlignment={'left'}>
                <div data-testid="step-header">
                    <Stack space="1.5bu">
                        {step.hasStepBefore() && (
                            <Link
                                behaviour={BehaviourReactRouterLink}
                                size="size2"
                                href={step.prevUrl()}
                                underline="hover"
                                color={colors.grey700}
                            >
                                <Box as="span" marginRight="0.25bu">
                                    <IconLeft1 />
                                </Box>
                                {__('Back')}
                            </Link>
                        )}

                        <Box display="flex" alignItems="center">
                            <Box flex={1}>
                                <h2 className={'heading heading--h2 heading--no-margin'}>
                                    {step.currentStep().stepHeading
                                        ? step.currentStep().stepHeading
                                        : step.currentStep().title}
                                </h2>
                            </Box>
                            <Heading size="h5" margin="no">
                                {step.currentStepNumber}
                                {' / '}
                                <Muted>{step.stepCount()}</Muted>
                            </Heading>
                        </Box>

                        {!step.isDesignerStep() && designers.length > 0 && (
                            <HeaderUserLayout users={designers} />
                        )}

                        {partner && <PartnerLogo partner={partner} />}

                        {briefProduct && step.hasStepAfter() && !step.isInvoiceStep() && (
                            <Box display="inline-block">
                                <BriefPackage product={briefProduct} collapsed />
                            </Box>
                        )}
                    </Stack>
                </div>
            </Header>
        </ContentSetting>
    );
}
